import React from 'react';

const QuickActions = ({ fetchPayrolls, navigate, canAddPayroll, handleAdd }) => {
    return (
        <div className="row mt-4">
            <div className="col-12">
                <div className="card border-0">
                    <div className="card-body text-center py-3">
                        <div className="btn-group" role="group">
                            <button
                                className="btn btn-outline-primary"
                                onClick={fetchPayrolls}
                            >
                                <i className="bi bi-arrow-clockwise me-2"></i>
                                Refresh Data
                            </button>
                            <button
                                className="btn btn-outline-success"
                                onClick={() => navigate('/employees')}
                            >
                                <i className="bi bi-people me-2"></i>
                                Manage Employees
                            </button>
                            <button
                                className="btn btn-outline-info"
                                onClick={() => navigate('/holidays')}
                            >
                                <i className="bi bi-calendar-event me-2"></i>
                                Holidays
                            </button>
                            {canAddPayroll && (
                                <button
                                    className="btn btn-primary text-white"
                                    onClick={handleAdd}
                                >
                                    <i className="bi bi-plus-circle me-2"></i>
                                    Add New Payroll Period
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuickActions;